import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { t } from '../../services/i18nService';
import styles from './header.scss';
import inlineSubHeaderTextSelector from '../../selectors/header/InlineSubHeaderSelector';
import LivestreamStatus from './LivestreamStatus';

const InlineSubHeader = (props) => {
    const {
        audioStatusCaption,
        showControllableAudioNotPlayingStatus,
        showControllableAudioPlayingStatus,
        showDefaultAudioStatus,
        showLivestreamStatus,
        showRecordingStatus,
    } = props;

    const statusClassList = `${styles.inlineSubHeaderText} ${styles.audioStatus}`;
    return (
        <React.Fragment>
            { showRecordingStatus &&
                <span className={`${styles.inlineSubHeaderText} ${styles.recordingSubHeaderText}`}>
                    <i className="fa fa-circle" aria-hidden />
                    <span className={styles.subHeaderTitle}>
                        { t('header.recording') }
                    </span>
                </span>
            }

            { showDefaultAudioStatus &&
                <span className={styles.inlineSubHeaderText}>
                    <i className="fa fa-volume-up" aria-hidden />
                    <span className={styles.subHeaderTitle}>
                        { t('session.backgroundAudioIsPlaying') }
                    </span>
                </span>
            }

            { showLivestreamStatus && <LivestreamStatus /> }

            { showControllableAudioPlayingStatus &&
                <span className={statusClassList}>
                    <i className="fa fa-volume-up" aria-hidden />
                    <span className={styles.subHeaderTitle}>
                        { audioStatusCaption }
                    </span>
                </span>
            }

            { showControllableAudioNotPlayingStatus &&
                <span className={statusClassList}>
                    <i className="fa fa-volume-off" aria-hidden />
                    <i className={`fa fa-times ${styles.subIcon}`} aria-hidden />
                    <span className={styles.subHeaderTitle}>
                        { audioStatusCaption }
                    </span>
                </span>
            }

            { audioStatusCaption &&
                <span role="alert" aria-live="assertive" className="sr-only">
                    { audioStatusCaption }
                </span>
            }
        </React.Fragment>
    );
};

InlineSubHeader.propTypes = {
    audioStatusCaption: PropTypes.string,
    showControllableAudioNotPlayingStatus: PropTypes.bool.isRequired,
    showControllableAudioPlayingStatus: PropTypes.bool.isRequired,
    showDefaultAudioStatus: PropTypes.bool.isRequired,
    showLivestreamStatus: PropTypes.bool.isRequired,
    showRecordingStatus: PropTypes.bool.isRequired,
};

const mapStateToProps = state => inlineSubHeaderTextSelector.selectProps(state);
export default connect(mapStateToProps)(InlineSubHeader);
